<template>
  <b-container>
    <b-row>
      <b-button to="/dictionary">Dictionary</b-button>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "HomePage"
}
</script>

<style scoped>

</style>